import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { PageExplorerLayout } from '../entities/page-explorer-layout';
import { ExplorerProvider } from '../providers/explorer-provider';
import { BackButtonEntityProvider, EntityTypeBannersProvider, PAGE_HOME, PageHalfBanner } from '@shapeable/ui';

const cls = classNames('page-layout-default');

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const LayoutStyles = breakpoints({
  base: css`
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
  Layout: styled(PageExplorerLayout)`${LayoutStyles}`,
};

export const PageLayoutDefault: PageLayoutComponent = (props) => {
  const { className, entity, slices } = props;

  const backEntity = entity.parent && entity.parent.id !== entity.id ? entity.parent : PAGE_HOME;

  return (
    <My.Container className={cls.name(className)}>
      <ExplorerProvider>
      <BackButtonEntityProvider value={backEntity}>
        <My.Layout 
          entity={entity} 
          showRadar 
          isAsideSticky={false}
          className={className} 
        />
      </BackButtonEntityProvider>
      </ExplorerProvider>
    </My.Container>
  )
};
